import { render, staticRenderFns } from "./MilestoneActivity.vue?vue&type=template&id=efcfe2bc"
import script from "./MilestoneActivity.vue?vue&type=script&lang=js"
export * from "./MilestoneActivity.vue?vue&type=script&lang=js"
import style0 from "./MilestoneActivity.vue?vue&type=style&index=0&id=efcfe2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports